import { useMemo } from "react";

import { useAppConfigQuery } from "#/features/User/queries";
import { useFacilityById } from "@/common/AppConfigUtils";
import { useCurrentSelectedUnitId } from "@/common/hooks";

/**
 * Returns hierarchy ids from useCurrentSelectedUnitId() and useAppConfigQuery().
 */
export const useHierarchySelected = () => {
  const appConfig = useAppConfigQuery();
  const currentUnitId = useCurrentSelectedUnitId();
  const facilitiesById = useFacilityById();

  const selected = useMemo(() => {
    // computed from unit config to get health system
    const unitConfig = appConfig?.data?.units?.find((unit) => unit.id === currentUnitId);
    const unitId = currentUnitId;
    const facilityId = unitConfig?.facilityId;
    const healthSystemId = unitConfig?.facility?.healthSystemId;

    // computed from health system to get region and market searching through facilities / regions / markets
    const healthSystem = appConfig.data?.healthSystems?.find(
      (system) => system.id === healthSystemId,
    );
    const healthSystemFacilityId = healthSystem?.facilityIds.find(
      (hsFacilityId) => hsFacilityId === facilityId,
    );
    const facility = (healthSystemFacilityId && facilitiesById[healthSystemFacilityId]) || null;
    const marketId = facility?.marketId;
    const region = healthSystem?.regions?.find((reg) => {
      const [found] = reg.markets.filter((mar) => mar.id === marketId);
      return found;
    });
    const regionId = region?.id;
    const market = region?.markets.find((mar) => mar.id === marketId);

    return {
      unitId,
      unit: unitConfig,
      facility,
      facilityId,
      market,
      marketId,
      region,
      regionId,
      healthSystem,
      healthSystemId,
      idsMap: [healthSystemId, regionId, marketId, facilityId, unitId],
    };
  }, [appConfig.data?.healthSystems, appConfig.data?.units, currentUnitId, facilitiesById]);

  return selected;
};
